import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { _cookie, _route } from "@/utils/constant";
import { ReactNode } from "react";

const AuthRoute = ({ children }: { children: ReactNode }) => {
  const authenticated = !!Cookies.get(_cookie.TOKEN);

  return authenticated
    ? children
    : ((
        <Navigate to={`${_route.LOGIN}?redirect=${encodeURIComponent(window.location.href)}`} />
      ) as any);
};

export default AuthRoute;
